import { baseAPI } from 'api/instance';
import { apiErrorHandler } from 'api';
import { MapGeoJSONFeature } from 'react-map-gl';

// delevery api
type TProcessStatus = 'completed' | 'arrived' | 'processing' | 'scheduled';
type TRequestGetMessageDeliveryParams = {
  encryptId: string;
};
type TCoordinate = { type: string | TProcessStatus | null; coordinates: number[] };
type THistory = {
  type: string | TProcessStatus | null;
  createdAt: string | null;
};
export type TResponseGetMessageDelivery = {
  orderInfo: {
    eta: string | null;
    status: string | TProcessStatus | null;
    driver: {
      driverId: number | null;
      name: string | null;
    };
    order: {
      orderId: number | null;
      address: string | null;
      detailAddress: string | null;
      completedAt: string | null;
      consigneeName: string | null;
      createdAt: string | null;
      orderCode: string | null;
      coordinate: TCoordinate;
    };
  };
  history: THistory[];
  s3Files: string[];
};
export const getMessageDelivery = async (props: TRequestGetMessageDeliveryParams) => {
  try {
    const URL = `/message/delivery/${[props.encryptId]}`;
    const token = window.localStorage.getItem('accessToken') || '';
    const { data } = await baseAPI({ url: URL, method: 'GET', headers: { token } });
    return data as TResponseGetMessageDelivery;
  } catch (err) {
    const error = apiErrorHandler(err);
    // return error;
  }
};

// 실제 경로 api (GET)
type TRequestRealRouteParams = {
  encryptId: string;
  driverId: number;
};
export type TResponseRealRoute = MapGeoJSONFeature[];
export const getRealRoute = async (props: TRequestRealRouteParams) => {
  try {
    const URL = `/message/delivery/location/actual/${props.encryptId}/${props.driverId}`;
    const token = window.localStorage.getItem('accessToken') || '';
    const { data } = await baseAPI({ url: URL, method: 'GET', headers: { token } });
    return data as TResponseRealRoute;
  } catch (err) {
    const error = apiErrorHandler(err);
    // return error;
  }
};
